module.exports = __webpack_public_path__ + "img/icon-arrow-dark.13f02fad.svg";